import Vue from "vue";
import Router from "vue-router";
const ls = require("local-storage");
import { getState } from "./state";

import usuariosRouter from "./views/Usuarios/usuariosRouter";
import administradorRouter from "./views/administrador/administradorRouter";

Vue.use(Router);

const verificandoAutorizacao = (to, from, next) => {
  const state = getState();
  if (to.path != "/") {
    const rotaAtual = { to: to.path, text: to.name };
    const indiceRotaAtual = state.paginas.findIndex(
      (rota) => rota.to == rotaAtual.to && rota.text == rotaAtual.text
    );
    if (indiceRotaAtual === -1) {
      state.paginas.push(rotaAtual);
    } else {
      // Se o objeto existe no array, eliminar todos os objetos depois dele
      state.paginas.splice(indiceRotaAtual + 1);
    }
  } else {
    state.paginas = [];
    ls.clear();
  }

  // Verifique se já estamos no processo de redirecionamento para evitar um loop infinito
  if (to.meta.isRedirecting) {
    next();
    return;
  }

  const rotas = JSON.parse(ls.get("rotas"));
  if (rotas && rotas.length) {
    const autorizacao = rotas.some(
      (objeto) =>
        objeto.url.trim().toUpperCase() === to.path.trim().toUpperCase()
    );
    if (!autorizacao) {
      return next("/negado");
    } else {
      next();
    }
  } else {
    next();
  }
};

const routes = [
  ...usuariosRouter,
  ...administradorRouter,

  // ROTAS HOME
  {
    path: "/esc-welcome",
    meta: { layout: "default" },
    name: "Home",
    component: () => import("./views/fin-escola/Welcome.vue"),
  },

  // ROTAS MENU PAGAMENTOS
  {
    path: "/esc-pagamento",
    name: "Pagamento",
    meta: { layout: "default" },
    component: () => {
      const fkNegocio = ls.get("fkNegocio");
      if (fkNegocio == 12) {
        return import("./views/pagamentos/Pagamento.vue");
      } else {
        return import("./views/pagamentos/Pagamento-empresa.vue");
      }
    },
  },

  {
    path: "/faturas-anuladas",
    name: "faturacao-vendass",
    meta: { layout: "default" },
    component: () => import("./views/pagamentos/faturacao-anuladas.vue"),
  },
  {
    path: "/faturacao-vendas",
    name: "pagamentos Feitos",
    meta: { layout: "default" },
    component: () => import("./views/pagamentos/faturacao-vendas.vue"),
  },
  {
    path: "/fecho-caixa",
    meta: { layout: "default" },
    name: "Fecho de caixa individual",
    component: () => import("./views/pagamentos/FechoCaixa.vue"),
  },
  {
    path: "/fecho-caixa-geral",
    meta: { layout: "default" },
    name: "Fecho de caixa geral",
    component: () => import("./views/pagamentos/FechoCaixaGeral.vue"),
  },
  {
    path: "/registro-facturas",
    meta: { layout: "default" },
    name: "Registro de Factura",
    component: () => import("./views/pagamentos/RegistroFactura.vue"),
  },

  {
    path: "/pagamentos/menu",
    name: "Menu Pagamentos",
    meta: { layout: "default" },
    component: () => import("./views/pagamentos/menu.vue"),
  },
  {
    path: "/faturas-duplicadas",
    name: "Faturas Duplicadas",
    meta: { layout: "default" },
    component: () => import("./views/pagamentos/Faturas-Duplicadas.vue"),
  },

  // ROTAS MENU BOLSEIROS
  {
    path: "/bolseiros/menu",
    name: "Menu Bolseiros",
    meta: { layout: "default" },
    component: () => import("./views/bolseiros/menu.vue"),
  },
  {
    path: "/listar-bolseiros-activos",
    meta: { layout: "default" },
    name: "Listar Bolseiros Activos",
    component: () => import("./views/bolseiros/bolseirosListagem.vue"),
  },
  {
    path: "/listar-bolseiros-revogados",
    meta: { layout: "default" },
    name: "Listar Bolseiros Revogados",
    component: () => import("./views/bolseiros/bolseirosListagemRevogados.vue"),
  },

  // ROTAS RELATÓRIOS
  {
    path: "/relatorios/menu",
    name: "Menu Relatorios",
    meta: { layout: "default" },
    component: () => import("./views/relatorios/menu.vue"),
  },

  {
    path: "/esc-relatorio-entradas",
    meta: { layout: "default" },
    name: "Relatório de entradas escola",
    component: () => import("./views/relatorios/relatorios_entradas_esc.vue"),
  },

  {
    path: "/relatorio-turma-pdf",
    meta: { layout: "default" },
    name: "Relatorio Turma pdf",
    component: () =>
      import("./views/relatorios/relatorioComponentes/emolumentoTurmaPdf.vue"),
  },

  // ROTA MENU ADMINISTRADOR

  {
    path: "/menu-items",
    name: "Items dos Menus",
    meta: { layout: "default" },
    component: () => import("./views/administrador/ListarMenuItems.vue"),
  },
  {
    path: "/painel-funcoes",
    name: "Painel Funções Por Role",
    meta: { layout: "default" },
    component: () => import("./views/administrador/ListarFuncoesPorRole.vue"),
  },

  {
    path: "/menu-instituicao",
    name: "Menu Instituição",
    meta: { layout: "default" },
    component: () => import("./views/administrador/menu-instituicao.vue"),
  },
  {
    path: "/registros-funcionario",
    name: "Registros Funcionário",
    meta: { layout: "default" },
    component: () => import("./views/administrador/Registros-Funcionario.vue"),
  },
  {
    path: "/registros-estudante",
    name: "Registros Estudante",
    meta: { layout: "default" },
    component: () => import("./views/administrador/Registros-Estudante.vue"),
  },

  {
    path: "/bancos/associacao-contas",
    name: "associal contas bancarias",
    meta: { layout: "default" },
    component: () => import("./views/bancos/AssociarBanco.vue"),
  },

  {
    path: "/",
    name: "login",
    meta: { layout: "no-sidebar" },
    component: () => import("./views/mod-fin/Login.vue"),
  },
  {
    path: "/config-empresa",
    name: "cfg-DadosEmpresa",
    meta: { layout: "no-sidebar" },
    component: () => import("./views/mod-fin/cfg-DadosEmpresa.vue"),
  },
  {
    path: "/agt/saft",
    name: "Agt-saft",
    meta: { layout: "default" },
    component: () => import("./views/mod-fin/Agt-saft.vue"),
  },
  {
    path: "/pesquisaEstudanteFinancas",
    meta: { layout: "default" },
    name: "pesquisaEstudanteFinancas",
    component: () => import("./views/mod-fin/pesquisaEstudanteFinancas.vue"),
  },
  {
    path: "/painelclasses-servicos",
    name: "login",
    meta: { layout: "default" },
    component: () => import("./views/mod-fin/cadastrar-servicos.vue"),
  },
  {
    path: "/detalhes-movimentacao-banco",
    name: "detalhes-movimentacao-banco",
    meta: { layout: "default" },
    component: () => import("./views/mod-fin/detalhes-movimentos-contas.vue"),
  },

  {
    path: "/relatorios",
    name: "login",
    meta: { layout: "default" },
    component: () => import("./views/mod-fin/relatorios.vue"),
  },
  {
    path: "/imprimir-factura",
    meta: { layout: "no-sidebar" },
    name: "imprimir-factura",
    component: () => import("./views/mod-fin/imprimir-factura.vue"),
  },
  {
    path: "/relatorios",
    meta: { layout: "no-sidebar" },
    name: "relatorios",
    component: () => import("./views/mod-fin/relatorios.vue"),
  },
  {
    path: "/logs_sistema",
    meta: { layout: "no-sidebar" },
    name: "logs_sistema",
    component: () => import("./views/mod-fin/logs_sistema.vue"),
  },
  {
    path: "/relatorio_cadastro",
    meta: { layout: "no-sidebar" },
    name: "relatorio_cadastro",
    component: () => import("./views/mod-fin/relatorio_cadastro.vue"),
  },
  {
    path: "/imprimir_relatorio_cadastro",
    meta: { layout: "no-sidebar" },
    name: "imprimir_relatorio_cadastro",
    component: () => import("./views/mod-fin/imprimir_relatorio_cadastro.vue"),
  },
  {
    path: "/imprimir_pdf",
    meta: { layout: "no-sidebar" },
    name: "imprimir_pdf",
    component: () => import("./views/mod-fin/imprimir_pdf.vue"),
  },

  {
    path: "/relatorios_vendas",
    meta: { layout: "no-sidebar" },
    name: "relatorios_vendas",
    component: () => import("./views/mod-fin/relatorios_vendas.vue"),
  },

  {
    path: "/extrato-conta-corrente",
    meta: { layout: "default" },
    name: "Relatório extrato conta corrente - detalhes",
    component: () =>
      import("./views/fin-escola/relatorio_extrato_conta_corrente.vue"),
  },
  {
    path: "/assistente",
    meta: { layout: "default" },
    name: "Assistente configuracao",
    component: () =>
      import(
        "./views/fin-escola/configuracaoComponentes/assistenteConfiguracao.vue"
      ),
  },
  {
    path: "/esc-relatorios-estudantes-cadastrados",
    meta: { layout: "default" },
    name: "Relatório de estudantes cadastrados",
    component: () =>
      import("./views/fin-escola/relatorios_estudantes_cadastrados.vue"),
  },
  {
    path: "/relatorio-dos-estudantes",
    meta: { layout: "default" },
    name: "Relatório das actividades financeiras dos estudantes",
    component: () => import("./views/fin-escola/relatorio_dos_estudantes.vue"),
  },
  {
    path: "/definir-feriados",
    meta: { layout: "default" },
    name: "Definir Feriados",
    component: () => import("./views/mod-fin/feriados.vue"),
  },
  {
    path: "/imprimir_relatorio_venda",
    meta: { layout: "no-sidebar" },
    name: "imprimir_relatorio_venda",
    component: () => import("./views/mod-fin/imprimir_relatorio_venda.vue"),
  },
  {
    path: "/cadastrar-conta-banco",
    name: "login",
    meta: { layout: "default" },
    component: () => import("./views/mod-fin/cadastrar-conta-banco.vue"),
  },
  {
    path: "/cadastrar-propina-preco",
    name: "cadastrar-propina-preco",
    meta: { layout: "default" },
    component: () => import("./views/mod-fin/cadastrar-propina-preco.vue"),
  },
  {
    path: "/pesquisar-propinas-preco",
    name: "login",
    meta: { layout: "default" },
    component: () => import("./views/mod-fin/pesquisar-propinas-preco.vue"),
  },

  {
    path: "/pesquisar-conta-banco",
    name: "login",
    meta: { layout: "default" },
    component: () => import("./views/mod-fin/conta-bancaria-pesquisa.vue"),
  },

  {
    path: "/consultar-valor",
    name: "login",
    meta: { layout: "default" },
    component: () => import("./views/mod-fin/pesquisar-multas-valor.vue"),
  },
  {
    path: "/cadastrar-precos",
    name: "login",
    meta: { layout: "default" },
    component: () => import("./views/mod-fin/cadastrar-precos.vue"),
  },
  {
    path: "/cadastrar-series",
    name: "login",
    meta: { layout: "default" },
    component: () => import("./views/mod-fin/cadastrar-serie.vue"),
  },
  {
    path: "/pagamento-outros-servicos",
    name: "login",
    meta: { layout: "default" },
    component: () => import("./views/mod-fin/pagamento-outros-servicos.vue"),
  },

  {
    path: "/licenca-expirada",
    meta: { layout: "default" },
    name: "licenca-expirada",
    component: () => import("./views/mod-fin/servico-suspenso.vue"),
  },
  {
    path: "/no-available-2",
    meta: { layout: "default" },
    name: "no-available",
    component: () => import("./views/mod-fin/no-available.vue"),
  },
  {
    path: "/pagamento-mensalidade",
    name: "login",
    meta: { layout: "default" },
    component: () => import("./views/mod-fin/pagamento-mensalidade.vue"),
  },
  {
    path: "/Novo-Produto",
    name: "Novo-Produto",
    meta: { layout: "default" },
    component: () => import("./views/administrador/Novo-Produto.vue"),
  },

  {
    path: "/editar-emolumento",
    name: "Editar-Emolumento",
    meta: { layout: "default" },
    component: () => import("./views/fin-escola/EditarProduto.vue"),
  },

  {
    path: "/Novo-Fornecedor",
    name: "Novo-Fornecedor",
    meta: { layout: "default" },
    component: () => import("./views/mod-fin/Novo-Fornecedor.vue"),
  },
  {
    path: "/Novo-Cliente",
    name: "Novo-Cliente",
    meta: { layout: "default" },
    component: () => import("./views/mod-fin/Novo-Cliente.vue"),
  },
  {
    path: "/Cliente-informacoes",
    name: "Cliente-informacoes",
    meta: { layout: "default" },
    component: () => import("./views/mod-fin/cliente-informacoes.vue"),
  },
  {
    path: "/Stock-informacoes",
    name: "Stock-informacoes",
    meta: { layout: "default" },
    component: () => import("./views/mod-fin/Stock/Listagem.vue"),
  },
  {
    path: "/listagem-produtos",
    name: "listagem-produtos",
    meta: { layout: "default" },
    component: () => import("./views/mod-fin/Stock/listagemProdutos.vue"),
  },
  {
    path: "/valorizacao-stock",
    name: "valorizacao-stock",
    meta: { layout: "default" },
    component: () => import("./views/mod-fin/Stock/valorizacaoStock.vue"),
  },
  {
    path: "/existenciaArmazem",
    name: "existenciaArmazem",
    meta: { layout: "default" },
    component: () => import("./views/mod-fin/Stock/existenciaArmazem.vue"),
  },
  {
    path: "/clientePorProduto",
    name: "clientePorProduto",
    meta: { layout: "default" },
    component: () => import("./views/mod-fin/Stock/clientesPorProduto.vue"),
  },
  {
    path: "/listar-clientes",
    name: "listar-clientes",
    meta: { layout: "default" },
    component: () => import("./views/mod-fin/Stock/listar-clientes.vue"),
  },
  {
    path: "/MovimentosclientePorProduto",
    name: "MovimentosclientePorProduto",
    meta: { layout: "default" },
    component: () =>
      import("./views/mod-fin/Stock/movimentosClientesPorProdutos.vue"),
  },
  {
    path: "/listagemSimples-cliente",
    name: "listagemSimples-cliente",
    meta: { layout: "default" },
    component: () =>
      import("./views/mod-fin/ListagemCliente/listagemSimple.vue"),
  },
  {
    path: "/contaCorrente-cliente",
    name: "contaCorrente-cliente",
    meta: { layout: "default" },
    component: () =>
      import("./views/mod-fin/ListagemCliente/contaCorrente.vue"),
  },
  // {
  //   path: '/faturacao-vendas',
  //   name: 'faturacao-vendas',
  //   meta: { layout: 'default' },
  //   component: () => import('./views/mod-fin/faturacao-vendas.vue')
  // },
  {
    path: "/faturas-proformas",
    name: "faturas proformas",
    meta: { layout: "default" },
    component: () => import("./views/mod-fin/faturas-proformas.vue"),
  },
  // {
  //   path: '/faturas-anuladas',
  //   name: 'faturacao-vendass',
  //   meta: { layout: 'default' },
  //   component: () => import('./views/mod-fin/faturacao-anuladas.vue')
  // },
  {
    path: "/contaCorrente-stock",
    name: "contaCorrente-stock",
    meta: { layout: "default" },
    component: () => import("./views/mod-fin/Stock/contaCorrente.vue"),
  },
  {
    path: "/contaCorrente-Dispesas",
    name: "contaCorrente-stock",
    meta: { layout: "default" },
    component: () => import("./views/mod-fin/contaCorrenteDispesas.vue"),
  },
  {
    path: "/Nova-dispesa",
    name: "Nova-dispesa",
    meta: { layout: "default" },
    component: () => import("./views/mod-fin/Novo-dispesas.vue"),
  },
  {
    path: "/Nova-Outras-Entradas",
    name: "Nova-Outras-Entradas",
    meta: { layout: "default" },
    component: () => import("./views/mod-fin/Novo-Outras-Entrada.vue"),
  },
  {
    path: "/visualizar-dispesa",
    name: "visualizar-dispesa",
    meta: { layout: "default" },
    component: () => import("./views/mod-fin/Visualizar-dispesas.vue"),
  },
  {
    path: "/Nova-fatura",
    name: "Novo-Produto",
    meta: { layout: "default" },
    component: () => import("./views/mod-fin/Nova-fatura.vue"),
  },
  {
    path: "/relatorios-stock",
    name: "relatorios-stock",
    meta: { layout: "default" },
    component: () => import("./views/mod-fin/relatorios-Stock.vue"),
  },

  {
    path: "/Novo-Stock",
    name: "Novo-Stock-actualizado",
    meta: { layout: "default" },
    component: () => import("./views/mod-fin/Novo-Stock-actualizado.vue"),
  },
  {
    path: "/Movimentos-Stock",
    name: "Movimentos-Stock",
    meta: { layout: "default" },
    component: () => import("./views/mod-fin/Movimentos-Stock.vue"),
  },
  {
    path: "/detalhes-movimentacao",
    name: "detalhes-movimentacao",
    meta: { layout: "default" },
    component: () => import("./views/mod-fin/detalhes-movimentacao.vue"),
  },
  {
    path: "/detalhes-movimentacao-stock",
    name: "detalhes-movimentacao",
    meta: { layout: "default" },
    component: () => import("./views/mod-fin/detalhes-movimentacao-stock.vue"),
  },

  {
    path: "/Editar-Produto",
    name: "Editar-Produto",
    meta: { layout: "default" },
    component: () => import("./views/mod-fin/Editar-Produto.vue"),
  },
  {
    path: "/Novo-Produto2",
    name: "Novo-Produto",
    meta: { layout: "default" },
    component: () => import("./views/mod-fin/Novo-Produto2.vue"),
  },

  {
    path: "/Visualizar-Produto",
    name: "Novo-Produto",
    meta: { layout: "default" },
    component: () => import("./views/mod-fin/Visualizar-Produto.vue"),
  },

  {
    path: "/Visualizar-Faturas",
    name: "Visualizar-Faturas",
    meta: { layout: "default" },
    component: () => import("./views/mod-fin/Visualizar-Faturas.vue"),
  },
  {
    path: "/Visualizar-Fornecedor",
    name: "Novo-Produto",
    meta: { layout: "default" },
    component: () => import("./views/mod-fin/Visualizar-Fornecedor.vue"),
  },
  {
    path: "/caixasMesas",
    name: "caixasMesas",
    meta: { layout: "default" },
    component: () => import("./views/mod-fin/caixasMesas.vue"),
  },
  {
    path: "/Visualizar-Cliente",
    name: "Novo-Cliente",
    meta: { layout: "default" },
    component: () => import("./views/mod-fin/Visualizar-Cliente.vue"),
  },
  {
    path: "/cadastrar-servicos",
    name: "login",
    meta: { layout: "default" },
    component: () => import("./views/mod-fin/cadastrar-servicos.vue"),
  },

  {
    path: "/cadastrar-servicos-preco",
    name: "login",
    meta: { layout: "default" },
    component: () => import("./views/mod-fin/cadastrar-servicos-preco.vue"),
  },
  {
    path: "/pesquisar-precos",
    name: "login",
    meta: { layout: "default" },
    component: () => import("./views/mod-fin/precos-pesquisar.vue"),
  },
  {
    path: "/servicos-pesquisa",
    name: "login",
    meta: { layout: "default" },
    component: () => import("./views/mod-fin/servicos-pesquisa.vue"),
  },

  {
    path: "/plano-activo",
    meta: { layout: "default" },
    name: "plano-activo",
    component: () => import("./views/mod-fin/licenca.vue"),
  },
  {
    path: "/renovar-licenca",
    meta: { layout: "default" },
    name: "renovar-licenca",
    component: () => import("./views/mod-fin/renovar-licenca.vue"),
  },
  {
    path: "/adm-activar-licenca",
    meta: { layout: "default" },
    name: "renovar-licenca",
    component: () => import("./views/mod-fin/adm-activar-licenca.vue"),
  },
  {
    path: "/recibo-pagamento",
    name: "recibo-pagamento",
    meta: { layout: "default" },
    component: () => import("./views/fin-escola/reciboPagamento.vue"),
  },

  {
    path: "/gerar-notaCredito",
    meta: { layout: "default" },
    name: "welcome",
    component: () => import("./views/mod-fin/notaCredito.vue"),
  },
  {
    path: "/welcome",
    meta: { layout: "default" },
    name: "welcome",
    component: () => import("./views/mod-fin/Welcome.vue"),
  },
  {
    path: "/Dashboard",
    meta: { layout: "default" },
    name: "Dashboard",
    component: () => import("./views/mod-fin/Dashboard.vue"),
  },
  {
    path: "/Professor-disciplina-novo",
    meta: { layout: "default" },
    name: "welcome",
    component: () => import("./views/mod-fin/Professor-disciplina-novo.vue"),
  },
  {
    path: "/painelclasses",
    meta: { layout: "default" },
    name: "wpainelclasses",
    component: () => import("./views/mod-fin/painelclasses.vue"),
  },
  {
    path: "/painelClassTurma",
    meta: { layout: "default" },
    name: "painelClassTurma",
    component: () => import("./views/mod-fin/PainelClassTurma.vue"),
  },
  {
    path: "/turmacrud",
    meta: { layout: "default" },
    name: "turmacrud",
    component: () => import("./views/mod-fin/Turmacrud.vue"),
  },
  {
    path: "/Professor-disciplina-search",
    meta: { layout: "default" },
    name: "Professor-disciplina-search",
    component: () => import("./views/mod-fin/Professor-disciplina-search.vue"),
  },

  {
    path: "/funcionario",
    meta: { layout: "default" },
    name: "funcionario",
    component: () => import("./views/mod-fin/Funcionario.vue"),
  },
  {
    path: "/professor",
    meta: { layout: "default" },
    name: "professor",
    component: () => import("./views/mod-fin/Professor.vue"),
  },
  {
    path: "/painelgerirturmas",
    meta: { layout: "default" },
    name: "painelgerirturmas",
    component: () => import("./views/mod-fin/painelgerirturmas.vue"),
  },
  {
    path: "/lancar-trimestre-um",
    meta: { layout: "default" },
    name: "lancar-trimestre-um",
    component: () => import("./views/mod-fin/LancarNota1T.vue"),
  },
  {
    path: "/lancar-trimestre-dois",
    meta: { layout: "default" },
    name: "lancar-trimestre-dois",
    component: () => import("./views/mod-fin/LancarNota2T.vue"),
  },
  {
    path: "/lancar-trimestre-tres",
    meta: { layout: "default" },
    name: "lancar-trimestre-tres",
    component: () => import("./views/mod-fin/LancarNota3T.vue"),
  },

  {
    path: "/senhas",
    meta: { layout: "default" },
    name: "senhas",
    component: () => import("./views/mod-fin/Senhas.vue"),
  },

  {
    path: "/abrir-fechar-anolectivo",
    meta: { layout: "default" },
    name: "abrir-fechar-anolectivo",
    component: () => import("./views/mod-fin/abrir-fechar-anolectivo.vue"),
  },
  {
    path: "/about",
    meta: { layout: "default" },
    name: "about",
    component: () => import("./views/mod-fin/About.vue"),
  },
  {
    path: "/contacts",
    meta: { layout: "default" },
    name: "contacts",
    component: () => import("./views/mod-fin/Contacts.vue"),
  },
  {
    path: "/senhas-painel",
    meta: { layout: "default" },
    name: "senhas-painel",
    component: () => import("./views/mod-fin/senhas-painel.vue"),
  },
  {
    path: "/estudante",
    meta: { layout: "default" },
    name: "estudante",
    component: () => import("./views/mod-fin/Estudante.vue"),
  },
  {
    path: "/cadeira",
    meta: { layout: "default" },
    name: "cadeira",
    component: () => import("./views/mod-fin/Cadeira.vue"),
  },
  {
    path: "/listarCadeira",
    meta: { layout: "default" },
    name: "listarCadeira",
    component: () => import("./views/mod-fin/listarCadeiras.vue"),
  },
  {
    path: "/notasCadeira",
    meta: { layout: "default" },
    name: "notasCadeira",
    component: () => import("./views/mod-fin/notasCadeira"),
  },
  {
    path: "/listarInscritos",
    meta: { layout: "default" },
    name: "listarInscritos",
    component: () => import("./views/mod-fin/listaInscritos"),
  },
  {
    path: "/perfil",
    meta: { layout: "default" },
    name: "perfil",
    component: () => import("./views/mod-fin/perfil"),
  },
  {
    path: "/ListaAlunos",
    meta: { layout: "default" },
    name: "ListaAlunos",
    component: () => import("./views/mod-fin/ListarAlunosTurma"),
  },
  {
    path: "/Mudar_curso",
    meta: { layout: "default" },
    name: "Mudar_curso",
    component: () => import("./views/mod-fin/MudarCurso"),
  },
  {
    path: "/Mudar_instituicao",
    meta: { layout: "default" },
    name: "Mudar_curso",
    component: () => import("./views/mod-fin/MudarInstituicao"),
  },
  {
    path: "/Boletim",
    meta: { layout: "default" },
    name: "boletim",
    component: () => import("./views/mod-fin/boletim"),
  },
  {
    path: "/enquadramento",
    meta: { layout: "default" },
    name: "tabela",
    component: () => import("./views/mod-fin/enquadramento"),
  },

  {
    path: "/MudarInstituicao",
    meta: { layout: "default" },
    name: "MudarInstituicao",
    component: () => import("./views/mod-fin/MudarInstituicao"),
  },
  {
    path: "/SolicitarTransferencia",
    meta: { layout: "default" },
    name: "SolicitarTranferencia",
    component: () => import("./views/mod-fin/SolicitarTransferencia"),
  },
  {
    path: "/ListarTransferido",
    meta: { layout: "default" },
    name: "ListarTransferido",
    component: () => import("./views/mod-fin/ListarTransferido"),
  },
  {
    path: "/Transferir",
    meta: { layout: "default" },
    name: "Transferir",
    component: () => import("./views/mod-fin/Transferir"),
  },
  {
    path: "/AlunosPendentes",
    meta: { layout: "default" },
    name: "AlunosPendentes",
    component: () => import("./views/mod-fin/AlunosPendentes"),
  },
  {
    path: "/MudarEpoca",
    meta: { layout: "default" },
    name: "MudarEpoca",
    component: () => import("./views/mod-fin/MudarEpoca"),
  },
  {
    path: "/pesquisar-servicos",
    meta: { layout: "default" },
    name: "MudarEpoca",
    component: () => import("./views/mod-fin/pesquisar-servicos"),
  },
  {
    path: "/pesquisar-servicos-preco",
    meta: { layout: "default" },
    name: "MudarEpoca",
    component: () => import("./views/mod-fin/pesquisar-servicos-preco"),
  },
  {
    path: "/painelEstatistica",
    meta: { layout: "default" },
    name: "painelEstatistica",
    component: () => import("./views/mod-fin/painelEstatistica.vue"),
  },
  {
    path: "/estatistica",
    meta: { layout: "default" },
    name: "estatistica",
    component: () => import("./views/mod-fin/estatistica.vue"),
  },
  {
    path: "/AlunoCurso",
    meta: { layout: "default" },
    name: "AlunoCurso",
    component: () => import("./views/mod-fin/AlunoCurso.vue"),
  },
  {
    path: "/AlunoTurma",
    meta: { layout: "default" },
    name: "AlunoTurma",
    component: () => import("./views/mod-fin/AlunoTurma.vue"),
  },
  {
    path: "/AlunoClasse",
    meta: { layout: "default" },
    name: "AlunoClasse",
    component: () => import("./views/mod-fin/AlunoClasse.vue"),
  },
  {
    path: "/pesquisaLocal",
    meta: { layout: "default" },
    name: "pesquisaLocal",
    component: () => import("./views/mod-fin/PesquisaLocal.vue"),
  },
  {
    path: "/pesquisaGlobal",
    meta: { layout: "default" },
    name: "pesquisaGlobal",
    component: () => import("./views/mod-fin/PesquisaGlobal.vue"),
  },
  {
    path: "/transferencia",
    meta: { layout: "default" },
    name: "transferencia",
    component: () => import("./views/mod-fin/solicitar-transferencia.vue"),
  },
  {
    path: "/pedidos-transferencia",
    meta: { layout: "default" },
    name: "pedidos-transferencia",
    component: () => import("./views/mod-fin/PesquisaLocal copy.vue"),
  },
  {
    path: "/enquadrar-transferidos",
    meta: { layout: "default" },
    name: "enquadrar-transferidos",
    component: () => import("./views/mod-fin/PesquisaLocal copy.vue"),
  },
  {
    path: "/AlunoInstituicao",
    meta: { layout: "default" },
    name: "AlunoInstituicao",
    component: () => import("./views/mod-fin/AlunoInstituicao.vue"),
  },
  {
    path: "/AlunoInstituicaoGeral",
    meta: { layout: "default" },
    name: "AlunoInstituicaoGeral",
    component: () => import("./views/mod-fin/AlunoInstituicaoGeral.vue"),
  },

  {
    path: "/AlunoCurso",
    meta: { layout: "default" },
    name: "AlunoCurso",
    component: () => import("./views/mod-fin/AlunoCurso.vue"),
  },
  {
    path: "/AlunoCursoGeral",
    meta: { layout: "default" },
    name: "AlunoCursoGeral",
    component: () => import("./views/mod-fin/AlunoCursoGeral.vue"),
  },
  {
    path: "/AlunoTurma",
    meta: { layout: "default" },
    name: "AlunoTurma",
    component: () => import("./views/mod-fin/AlunoTurma.vue"),
  },
  {
    path: "/AlunoTurmaGeral",
    meta: { layout: "default" },
    name: "AlunoTurmaGeral",
    component: () => import("./views/mod-fin/AlunoTurmaGeral.vue"),
  },
  {
    path: "/AlunoClasseGeral",
    meta: { layout: "default" },
    name: "AlunoClasseGeral",
    component: () => import("./views/mod-fin/AlunoClasseGeral.vue"),
  },
  {
    path: "/AlunoClasse",
    meta: { layout: "default" },
    name: "AlunoClasse",
    component: () => import("./views/mod-fin/AlunoClasse.vue"),
  },

  {
    path: "/ConfirmarInstituicao",
    meta: { layout: "default" },
    name: "ConfirmarInstituicao",
    component: () => import("./views/mod-fin/ConfirmarInstituicao.vue"),
  },
  {
    path: "/FuncionarioEstatistica",
    meta: { layout: "default" },
    name: "FuncionarioEstatistica",
    component: () => import("./views/mod-fin/FuncionarioEstatistica.vue"),
  },
  {
    path: "/FuncionarioEstatisticaGeral",
    meta: { layout: "default" },
    name: "FuncionarioEstatisticaGeral",
    component: () => import("./views/mod-fin/FuncionarioEstatisticaGeral.vue"),
  },

  {
    path: "/CadastrarInstituicao",
    meta: { layout: "default" },
    name: "CadastrarInstituicao",
    component: () => import("./views/mod-fin/CadastrarInstituicao.vue"),
  },
  {
    path: "/definir-prazo-multa",
    meta: { layout: "default" },
    name: "CadastrarInstituicao",
    component: () => import("./views/fin-escola/definir-prazo-multa.vue"),
  },

  {
    path: "/NotaFinalista",
    meta: { layout: "default" },
    name: "NotaFinalista",
    component: () => import("./views/mod-fin/NotasFinalista.vue"),
  },
  {
    path: "/NotaExame",
    meta: { layout: "default" },
    name: "NotaExame",
    component: () => import("./views/mod-fin/NotaExame.vue"),
  },
  {
    path: "/Mudar-Classe",
    meta: { layout: "default" },
    name: "Mudar-Classe",
    component: () => import("./views/mod-fin/MudarClasse.vue"),
  },
  {
    path: "/linechart",
    meta: { layout: "default" },
    name: "linechart",
    component: () => import("./views/mod-fin/analitics-view/LineChart.vue"),
  },
  {
    path: "/barchart",
    meta: { layout: "default" },
    name: "barchart",
    component: () => import("./views/mod-fin/analitics-view/BarChart.vue"),
  },
  {
    path: "/radar",
    meta: { layout: "default" },
    name: "radar",
    component: () => import("./views/mod-fin/analitics-view/RadarChart.vue"),
  },
  {
    path: "/area",
    meta: { layout: "default" },
    name: "area",
    component: () => import("./views/mod-fin/analitics-view/AreaChart.vue"),
  },
  {
    path: "/pie",
    meta: { layout: "default" },
    name: "pie",
    component: () => import("./views/mod-fin/analitics-view/PieChart.vue"),
  },
  {
    path: "/minhas-turmas",
    meta: { layout: "default" },
    name: "minhas-turmas",
    component: () => import("./views/mod-fin/minhas-turmas.vue"),
  },
  {
    path: "/denied",
    meta: { layout: "default" },
    name: "denied",
    component: () => import("./views/mod-fin/denied.vue"),
  },

  /**
   *  Rotas seperadas para o módulo escolar de facturação ===================================
   */

  {
    path: "/consultar-emolumentos",
    name: "Visualizar-Emolumentos",
    meta: { layout: "default" },
    component: () => import("./views/fin-escola/emolumentoListagem.vue"),
  },

  {
    path: "/pesquisar-cursos",
    meta: { layout: "default" },
    name: "Turmas",
    component: () => import("./views/fin-escola/cursoListagem.vue"),
  },
  {
    path: "/pesquisar-turmas",
    meta: { layout: "default" },
    name: "Turmas",
    component: () => import("./views/fin-escola/turmaListagem.vue"),
  },
  {
    path: "/pesquisar-estudantes",
    meta: { layout: "default" },
    name: "Estudantes",
    component: () => import("./views/fin-escola/estudantesListagem.vue"),
  },

  {
    path: "/estudante-componente",
    meta: { layout: "default" },
    name: "Estudantes",
    component: () =>
      import("./views/fin-escola/componentes/estudante/cadastrar.vue"),
  },
  {
    path: "/reportar-situacoes",
    meta: { layout: "default" },
    name: "resportar situacoes",
    component: () => import("./views/fin-escola/reportarSituacoes.vue"),
  },
  {
    path: "/pesquisar-estudantes-antigos",
    meta: { layout: "default" },
    name: "Estudantes",
    component: () => import("./views/fin-escola/estudantesListagemAntigo.vue"),
  },
  {
    path: "/pesquisar-comprovativos",
    meta: { layout: "default" },
    name: "comprovativos",
    component: () => import("./views/fin-escola/comprovativosListagem.vue"),
  },

  {
    path: "/actualizacao-academica",
    meta: { layout: "default" },
    name: "comprovativos",
    component: () => import("./views/fin-escola/enquadramento.vue"),
  },
  {
    path: "/negado",
    meta: { layout: "default" },
    name: "acesso negado",
    component: () => import("./views/mod-fin/acessoNegado.vue"),
  },
  {
    path: "/estudante-historico-pagamento",
    meta: { layout: "default" },
    name: "comprovativos",
    component: () => import("./views/fin-escola/historicoPagamento.vue"),
  },
  {
    path: "/pesquisar-devedores",
    meta: { layout: "default" },
    name: "Lista de Devedores",
    component: () => import("./views/fin-escola/devedores.vue"),
  },
  {
    path: "/devedores-propina",
    meta: { layout: "default" },
    name: "Devedores de propina",
    component: () => import("./views/fin-escola/devedores-propina.vue"),
  },

  {
    path: "/gerar-devedores",
    meta: { layout: "default" },
    name: "Gerar devedores",
    component: () => import("./views/fin-escola/devedoresPdf.vue"),
  },
  {
    path: "/pesquisar-meses-nao-pagos",
    meta: { layout: "default" },
    name: "Multas",
    component: () => import("./views/fin-escola/mesesNaoPagos.vue"),
  },

  {
    path: "/print-dividas",
    meta: { layout: "default" },
    name: "print recibo",
    component: () => import("./views/fin-escola/dividas.vue"),
  },
  {
    path: "/print-historico-pagamento",
    meta: { layout: "default" },
    name: "print recibo",
    component: () => import("./views/fin-escola/historicoPagamento-pdf.vue"),
  },
  {
    path: "/print-mensalidade",
    meta: { layout: "default" },
    name: "print mensalidades pagas",
    component: () => import("./views/fin-escola/report-mensalidadespagas.vue"),
  },

  {
    path: "/print-multas",
    meta: { layout: "default" },
    name: "print recibo",
    component: () => import("./views/fin-escola/pdf_multas.vue"),
  },

  {
    path: "/print-meses-nao-pagos",
    meta: { layout: "default" },
    name: "print recibo",
    component: () => import("./views/fin-escola/pdf_meses_nao_pagos.vue"),
  },
  {
    path: "/novo-comprovativo",
    name: "comprovativos",
    meta: { layout: "default" },
    component: () => import("./views/fin-escola/comprovativoNovo.vue"),
  },
  {
    path: "/imprimir-recibo-pagamento",
    name: "comprovativos",
    meta: { layout: "default" },
    component: () => import("./views/fin-escola/recibo-pagamento-escola.vue"),
  },
  {
    path: "/imprimir-recibo-pagamento-ilha",
    name: "comprovativos",
    meta: { layout: "default" },
    component: () =>
      import("./views/fin-escola/recibo-pagamento-escola-ilha.vue"),
  },
  {
    path: "/imprimir-recibo-pagamento-ilha-novo",
    name: "comprovativos",
    meta: { layout: "default" },
    component: () =>
      import("./views/fin-escola/recibo-pagamento-escola-ilha-novo.vue"),
  },
  {
    path: "/imprimir-ficha",
    name: "comprovativos",
    meta: { layout: "default" },
    component: () => import("./views/fin-escola/ficha-matricula.vue"),
  },
  {
    path: "/mensalidades-pagas",
    name: "mensalidades-pagas",
    meta: { layout: "default" },
    component: () => import("./views/fin-escola/mensalidadespagas.vue"),
  },

  /** ************************** ROTAS DO ADMINISTRADOR DO SISTEMA ******************************* */
  {
    path: "/info-instituicao",
    meta: { layout: "default" },
    name: "minhas-turmas",
    component: () => import("./views/mod-fin/configuracoes.vue"),
  },
  {
    path: "/definir-plano-financeiro",
    meta: { layout: "default" },
    name: "Ano semestre",
    component: () => import("./views/fin-escola/adm_definir_anoSemestre.vue"),
  },
  {
    path: "/planos-financeiro",
    meta: { layout: "default" },
    name: "Ano semestre",
    component: () =>
      import("./views/fin-escola/adm_listagem_plano_financeiro.vue"),
  },
];

const router = new Router({
  routes,
});

router.beforeEach(verificandoAutorizacao);

export default router;
